import Model from "./ModuleAttrModel.js";

export default {
  Section: {
    Global: {
      Title: Model.ModuleType.List.Name + " " + Model.Type.Global.Label + " " +
        Model.Module.FullName
    }
  }
}